import { produce as applyImmutably } from 'immer';
import { handleActions } from 'redux-actions';
import actions from '../../actions/satisfaction';
const { satisfactionLoadEmailGlobalSettingsRequest, satisfactionLoadEmailGlobalSettingsSucceeded, satisfactionLoadEmailGlobalSettingsFailed, satisfactionSaveEmailGlobalSettingsRequest, satisfactionSaveEmailGlobalSettingsSucceeded, satisfactionSaveEmailGlobalSettingsFailed, satisfactionLoadEmailContactLevelSettingsRequest, satisfactionLoadEmailContactLevelSettingsSucceeded, satisfactionLoadEmailContactLevelSettingsFailed, satisfactionSaveEmailContactLevelSettingsRequest, satisfactionSaveEmailContactLevelSettingsSucceeded, satisfactionSaveEmailContactLevelSettingsFailed, satisfactionLoadEmailLanguageLevelSettingsRequest, satisfactionLoadEmailLanguageLevelSettingsSucceeded, satisfactionLoadEmailLanguageLevelSettingsFailed, satisfactionSaveEmailLanguageLevelSettingsRequest, satisfactionSaveEmailLanguageLevelSettingsSucceeded, satisfactionSaveEmailLanguageLevelSettingsFailed, 
// ----------------------------------------------------------
satisfactionLoadChatGlobalSettingsRequest, satisfactionLoadChatGlobalSettingsSucceeded, satisfactionLoadChatGlobalSettingsFailed, satisfactionSaveChatGlobalSettingsRequest, satisfactionSaveChatGlobalSettingsSucceeded, satisfactionSaveChatGlobalSettingsFailed, satisfactionLoadChatContactLevelSettingsRequest, satisfactionLoadChatContactLevelSettingsSucceeded, satisfactionLoadChatContactLevelSettingsFailed, satisfactionSaveChatContactLevelSettingsRequest, satisfactionSaveChatContactLevelSettingsSucceeded, satisfactionSaveChatContactLevelSettingsFailed, satisfactionLoadChatLanguageLevelSettingsRequest, satisfactionLoadChatLanguageLevelSettingsSucceeded, satisfactionLoadChatLanguageLevelSettingsFailed, satisfactionSaveChatLanguageLevelSettingsRequest, satisfactionSaveChatLanguageLevelSettingsSucceeded, satisfactionSaveChatLanguageLevelSettingsFailed, 
// ----------------------------------------------------------
satisfactionLoadDixaMessengerGlobalSettingsRequest, satisfactionLoadDixaMessengerGlobalSettingsSucceeded, satisfactionLoadDixaMessengerGlobalSettingsFailed, satisfactionSaveDixaMessengerGlobalSettingsRequest, satisfactionSaveDixaMessengerGlobalSettingsSucceeded, satisfactionSaveDixaMessengerGlobalSettingsFailed, satisfactionLoadDixaMessengerContactLevelSettingsRequest, satisfactionLoadDixaMessengerContactLevelSettingsSucceeded, satisfactionLoadDixaMessengerContactLevelSettingsFailed, satisfactionSaveDixaMessengerContactLevelSettingsRequest, satisfactionSaveDixaMessengerContactLevelSettingsSucceeded, satisfactionSaveDixaMessengerContactLevelSettingsFailed, satisfactionLoadDixaMessengerLanguageLevelSettingsRequest, satisfactionLoadDixaMessengerLanguageLevelSettingsSucceeded, satisfactionLoadDixaMessengerLanguageLevelSettingsFailed, satisfactionSaveDixaMessengerLanguageLevelSettingsRequest, satisfactionSaveDixaMessengerLanguageLevelSettingsSucceeded, satisfactionSaveDixaMessengerLanguageLevelSettingsFailed, } = actions;
const initialState = {
    channels: {
        list: [],
        asyncStatus: 'loading',
    },
    customization: {
        widgetchat: {
            globalLevel: {
                values: null,
                asyncStatus: 'loading',
            },
            contactPointsLevel: {
                values: null,
                asyncStatus: 'loading',
            },
            languagesLevel: {
                values: null,
                asyncStatus: 'loading',
            },
        },
        email: {
            globalLevel: {
                values: null,
                asyncStatus: 'loading',
            },
            contactPointsLevel: {
                values: null,
                asyncStatus: 'loading',
            },
            languagesLevel: {
                values: null,
                asyncStatus: 'loading',
            },
        },
        messenger: {
            globalLevel: {
                values: null,
                asyncStatus: 'loading',
            },
            contactPointsLevel: {
                values: null,
                asyncStatus: 'loading',
            },
            languagesLevel: {
                values: null,
                asyncStatus: 'loading',
            },
        },
    },
};
export const satisfaction = handleActions({
    [satisfactionLoadEmailGlobalSettingsRequest.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.globalLevel.asyncStatus = 'loading';
        });
    },
    [satisfactionLoadEmailGlobalSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            // The Satisfaction api by default responds with a list of settings
            // but since there can only be 1 global settings, and we do the request
            // with the right parameters, it's safe to just pick the first item in the array.
            const globalSettings = action.payload.data.rating_settings[0] || null;
            const fallbackSettings = action.payload.data.default_rating_settings;
            const newState = applyImmutably(globalSettings, (draft) => {
                if (draft === null) {
                    return;
                }
                draft.customization = Object.assign(Object.assign({}, fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.customization), draft.customization);
                return;
            });
            draftState.customization.email.globalLevel.values = newState;
            draftState.customization.email.globalLevel.asyncStatus = 'succeeded';
        });
    },
    [satisfactionLoadEmailGlobalSettingsFailed.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.globalLevel.asyncStatus = 'failed';
        });
    },
    // ─────────────────────────────────────────────────────────────────
    [satisfactionSaveEmailGlobalSettingsRequest.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.globalLevel.asyncStatus = 'loading';
        });
    },
    [satisfactionSaveEmailGlobalSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.globalLevel.asyncStatus = 'succeeded';
            draftState.customization.email.globalLevel.values = action.payload.data;
        });
    },
    [satisfactionSaveEmailGlobalSettingsFailed.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.globalLevel.asyncStatus = 'failed';
        });
    },
    // ─────────────────────────────────────────────────────────────────
    [satisfactionLoadEmailContactLevelSettingsRequest.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.contactPointsLevel.asyncStatus =
                'loading';
        });
    },
    [satisfactionLoadEmailContactLevelSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.contactPointsLevel.asyncStatus =
                'succeeded';
            // Make sure that fallback customization is incorporated in the customization field of each setting.
            const fallbackSettings = state.customization.email.globalLevel.values;
            const settingsWithFallbackCustomization = action.payload.data.rating_settings.map((setting) => (Object.assign(Object.assign({}, setting), { customization: Object.assign(Object.assign({}, fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.customization), setting.customization) })));
            draftState.customization.email.contactPointsLevel.values =
                settingsWithFallbackCustomization;
        });
    },
    [satisfactionLoadEmailContactLevelSettingsFailed.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.contactPointsLevel.asyncStatus =
                'failed';
        });
    },
    // ─────────────────────────────────────────────────────────────────
    [satisfactionSaveEmailContactLevelSettingsRequest.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.contactPointsLevel.asyncStatus =
                'loading';
        });
    },
    [satisfactionSaveEmailContactLevelSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.contactPointsLevel.asyncStatus =
                'succeeded';
            draftState.customization.email.contactPointsLevel.values =
                action.payload.data.rating_settings;
        });
    },
    [satisfactionSaveEmailContactLevelSettingsFailed.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.contactPointsLevel.asyncStatus =
                'failed';
        });
    },
    // ─────────────────────────────────────────────────────────────────
    [satisfactionLoadEmailLanguageLevelSettingsRequest.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.languagesLevel.asyncStatus = 'loading';
        });
    },
    [satisfactionLoadEmailLanguageLevelSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            var _a;
            draftState.customization.email.languagesLevel.asyncStatus = 'succeeded';
            // Make sure that fallback customization is incorporated in the customization field of each setting.
            // for now we are assuming that there's only ONE contact point level settings and all language level
            // settings are a descendant of that one. this might change in the future.
            const fallbackSettings = (_a = state.customization.email.contactPointsLevel.values) === null || _a === void 0 ? void 0 : _a[0];
            const settingsWithFallbackCustomization = action.payload.data.rating_settings.map((setting) => (Object.assign(Object.assign({}, setting), { customization: Object.assign(Object.assign({}, fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.customization), setting.customization) })));
            draftState.customization.email.languagesLevel.values =
                settingsWithFallbackCustomization;
        });
    },
    [satisfactionLoadEmailLanguageLevelSettingsFailed.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.languagesLevel.asyncStatus = 'failed';
        });
    },
    // ─────────────────────────────────────────────────────────────────
    [satisfactionSaveEmailLanguageLevelSettingsRequest.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.languagesLevel.asyncStatus = 'loading';
        });
    },
    [satisfactionSaveEmailLanguageLevelSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.languagesLevel.asyncStatus = 'succeeded';
            const newSetting = action.payload.data;
            if (!draftState.customization.email.languagesLevel.values) {
                // State was empty! so we just initiate the state to this new setting.
                draftState.customization.email.languagesLevel.values = [newSetting];
                return;
            }
            // See whether we had this setting before or it a newly created setting.
            const index = draftState.customization.email.languagesLevel.values.findIndex(({ id }) => id === newSetting.id);
            if (index === -1) {
                // it's a new setting! so we just add it to the rest of settings.
                draftState.customization.email.languagesLevel.values.push(newSetting);
                return;
            }
            // It's an updated settings, so we just need to update it.
            draftState.customization.email.languagesLevel.values[index] =
                newSetting;
        });
    },
    [satisfactionSaveEmailLanguageLevelSettingsFailed.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.email.languagesLevel.asyncStatus = 'failed';
        });
    },
    // ─────────────────────────────────────────────────────────────────
    [satisfactionLoadChatGlobalSettingsRequest.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.globalLevel.asyncStatus = 'loading';
        });
    },
    [satisfactionLoadChatGlobalSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            // The Satisfaction api by default responds with a list of settings
            // but since there can only be 1 global settings, and we do the request
            // with the right parameters, it's safe to just pick the first item in the array.
            const globalSettings = action.payload.data.rating_settings[0] || null;
            const fallbackSettings = action.payload.data.default_rating_settings;
            const newState = applyImmutably(globalSettings, (draft) => {
                if (draft === null) {
                    return;
                }
                draft.customization = Object.assign(Object.assign({}, fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.customization), draft.customization);
                return;
            });
            draftState.customization.widgetchat.globalLevel.values = newState;
            draftState.customization.widgetchat.globalLevel.asyncStatus =
                'succeeded';
        });
    },
    [satisfactionLoadChatGlobalSettingsFailed.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.globalLevel.asyncStatus = 'failed';
        });
    },
    // ─────────────────────────────────────────────────────────────────
    [satisfactionSaveChatGlobalSettingsRequest.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.globalLevel.asyncStatus = 'loading';
        });
    },
    [satisfactionSaveChatGlobalSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.globalLevel.asyncStatus =
                'succeeded';
            draftState.customization.widgetchat.globalLevel.values =
                action.payload.data;
        });
    },
    [satisfactionSaveChatGlobalSettingsFailed.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.globalLevel.asyncStatus = 'failed';
        });
    },
    // ─────────────────────────────────────────────────────────────────
    [satisfactionLoadChatContactLevelSettingsRequest.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.contactPointsLevel.asyncStatus =
                'loading';
        });
    },
    [satisfactionLoadChatContactLevelSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.contactPointsLevel.asyncStatus =
                'succeeded';
            // Make sure that fallback customization is incorporated in the customization field of each setting.
            const fallbackSettings = state.customization.widgetchat.globalLevel.values;
            const settingsWithFallbackCustomization = action.payload.data.rating_settings.map((setting) => (Object.assign(Object.assign({}, setting), { customization: Object.assign(Object.assign({}, fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.customization), setting.customization) })));
            draftState.customization.widgetchat.contactPointsLevel.values =
                settingsWithFallbackCustomization;
        });
    },
    [satisfactionLoadChatContactLevelSettingsFailed.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.contactPointsLevel.asyncStatus =
                'failed';
        });
    },
    // ─────────────────────────────────────────────────────────────────
    [satisfactionSaveChatContactLevelSettingsRequest.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.contactPointsLevel.asyncStatus =
                'loading';
        });
    },
    [satisfactionSaveChatContactLevelSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.contactPointsLevel.asyncStatus =
                'succeeded';
            draftState.customization.widgetchat.contactPointsLevel.values =
                action.payload.data.rating_settings;
        });
    },
    [satisfactionSaveChatContactLevelSettingsFailed.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.contactPointsLevel.asyncStatus =
                'failed';
        });
    },
    // ─────────────────────────────────────────────────────────────────
    [satisfactionLoadChatLanguageLevelSettingsRequest.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.languagesLevel.asyncStatus =
                'loading';
        });
    },
    [satisfactionLoadChatLanguageLevelSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            var _a;
            draftState.customization.widgetchat.languagesLevel.asyncStatus =
                'succeeded';
            // Make sure that fallback customization is incorporated in the customization field of each setting.
            // for now we are assuming that there's only ONE contact point level settings and all language level
            // settings are a descendant of that one. this might change in the future.
            const fallbackSettings = (_a = state.customization.widgetchat.contactPointsLevel.values) === null || _a === void 0 ? void 0 : _a[0];
            const settingsWithFallbackCustomization = action.payload.data.rating_settings.map((setting) => (Object.assign(Object.assign({}, setting), { customization: Object.assign(Object.assign({}, fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.customization), setting.customization) })));
            draftState.customization.widgetchat.languagesLevel.values =
                settingsWithFallbackCustomization;
        });
    },
    [satisfactionLoadChatLanguageLevelSettingsFailed.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.languagesLevel.asyncStatus =
                'failed';
        });
    },
    // ─────────────────────────────────────────────────────────────────
    [satisfactionSaveChatLanguageLevelSettingsRequest.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.languagesLevel.asyncStatus =
                'loading';
        });
    },
    [satisfactionSaveChatLanguageLevelSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.languagesLevel.asyncStatus =
                'succeeded';
            const newSetting = action.payload.data;
            if (!draftState.customization.widgetchat.languagesLevel.values) {
                // State was empty! so we just initiate the state to this new setting.
                draftState.customization.widgetchat.languagesLevel.values = [
                    newSetting,
                ];
                return;
            }
            // See whether we had this setting before or it a newly created setting.
            const index = draftState.customization.widgetchat.languagesLevel.values.findIndex(({ id }) => id === newSetting.id);
            if (index === -1) {
                // it's a new setting! so we just add it to the rest of settings.
                draftState.customization.widgetchat.languagesLevel.values.push(newSetting);
                return;
            }
            // It's an updated settings, so we just need to update it.
            draftState.customization.widgetchat.languagesLevel.values[index] =
                newSetting;
        });
    },
    [satisfactionSaveChatLanguageLevelSettingsFailed.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.widgetchat.languagesLevel.asyncStatus =
                'failed';
        });
    },
    // ---------------------------------------------------------------------------
    // * Load global settings
    [satisfactionLoadDixaMessengerGlobalSettingsRequest.toString()](state) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.globalLevel.asyncStatus = 'loading';
        });
    },
    [satisfactionLoadDixaMessengerGlobalSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.globalLevel.asyncStatus =
                'succeeded';
            // The Satisfaction api by default responds with a list of settings
            // but since there can only be 1 global settings, and we do the request
            // with the right parameters, it's safe to just pick the first item in the array.
            const globalSettings = action.payload.data.rating_settings[0] || null;
            const fallbackSettings = action.payload.data.default_rating_settings;
            const newState = applyImmutably(globalSettings, (draft) => {
                if (draft === null) {
                    return;
                }
                draft.customization = Object.assign(Object.assign({}, fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.customization), draft.customization);
            });
            draftState.customization.messenger.globalLevel.values = newState;
            draftState.customization.messenger.globalLevel.asyncStatus =
                'succeeded';
        });
    },
    [satisfactionLoadDixaMessengerGlobalSettingsFailed.toString()](state) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.globalLevel.asyncStatus = 'failed';
        });
    },
    // * Save global settings
    [satisfactionSaveDixaMessengerGlobalSettingsRequest.toString()](state) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.globalLevel.asyncStatus = 'loading';
        });
    },
    [satisfactionSaveDixaMessengerGlobalSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.globalLevel.asyncStatus =
                'succeeded';
            draftState.customization.messenger.globalLevel.values =
                action.payload.data;
        });
    },
    [satisfactionSaveDixaMessengerGlobalSettingsFailed.toString()](state) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.globalLevel.asyncStatus = 'failed';
        });
    },
    // *  Load contact level settings
    [satisfactionLoadDixaMessengerContactLevelSettingsRequest.toString()](state) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.contactPointsLevel.asyncStatus =
                'loading';
        });
    },
    [satisfactionLoadDixaMessengerContactLevelSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.contactPointsLevel.asyncStatus =
                'succeeded';
            const fallbackSettings = state.customization.messenger.globalLevel.values;
            const settingsWithFallbackCustomization = action.payload.data.rating_settings.map((setting) => (Object.assign(Object.assign({}, setting), { customization: Object.assign(Object.assign({}, fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.customization), setting.customization) })));
            draftState.customization.messenger.contactPointsLevel.values =
                settingsWithFallbackCustomization;
        });
    },
    [satisfactionLoadDixaMessengerContactLevelSettingsFailed.toString()](state) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.contactPointsLevel.asyncStatus =
                'failed';
        });
    },
    // *  Save contact level settings
    [satisfactionSaveDixaMessengerContactLevelSettingsRequest.toString()](state) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.contactPointsLevel.asyncStatus =
                'loading';
        });
    },
    [satisfactionSaveDixaMessengerContactLevelSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.contactPointsLevel.asyncStatus =
                'succeeded';
            draftState.customization.messenger.contactPointsLevel.values =
                action.payload.data.rating_settings;
        });
    },
    [satisfactionSaveDixaMessengerContactLevelSettingsFailed.toString()](state) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.contactPointsLevel.asyncStatus =
                'failed';
        });
    },
    // *  Load language level settings
    [satisfactionLoadDixaMessengerLanguageLevelSettingsRequest.toString()](state) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.languagesLevel.asyncStatus =
                'loading';
        });
    },
    [satisfactionLoadDixaMessengerLanguageLevelSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            var _a;
            draftState.customization.messenger.languagesLevel.asyncStatus =
                'succeeded';
            // Make sure that fallback customization is incorporated in the customization field of each setting.
            // for now we are assuming that there's only ONE contact point level settings and all language level
            // settings are a descendant of that one. this might change in the future.
            const fallbackSettings = (_a = state.customization.messenger.contactPointsLevel.values) === null || _a === void 0 ? void 0 : _a[0];
            const settingsWithFallbackCustomization = action.payload.data.rating_settings.map((setting) => (Object.assign(Object.assign({}, setting), { customization: Object.assign(Object.assign({}, fallbackSettings === null || fallbackSettings === void 0 ? void 0 : fallbackSettings.customization), setting.customization) })));
            draftState.customization.messenger.languagesLevel.values =
                settingsWithFallbackCustomization;
        });
    },
    [satisfactionLoadDixaMessengerLanguageLevelSettingsFailed.toString()](state) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.languagesLevel.asyncStatus =
                'failed';
        });
    },
    // *  Save language level settings
    [satisfactionSaveDixaMessengerLanguageLevelSettingsRequest.toString()](state) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.languagesLevel.asyncStatus =
                'loading';
        });
    },
    [satisfactionSaveDixaMessengerLanguageLevelSettingsSucceeded.toString()](state, action) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.languagesLevel.asyncStatus =
                'succeeded';
            const newSetting = action.payload.data;
            if (!draftState.customization.messenger.languagesLevel.values) {
                // State was empty! so we just initiate the state to this new setting.
                draftState.customization.messenger.languagesLevel.values = [
                    newSetting,
                ];
                return;
            }
            // See whether we had this setting before or it a newly created setting.
            const index = draftState.customization.messenger.languagesLevel.values.findIndex(({ id }) => id === newSetting.id);
            if (index === -1) {
                // it's a new setting! so we just add it to the rest of settings.
                draftState.customization.messenger.languagesLevel.values.push(newSetting);
                return;
            }
            // It's an updated settings, so we just need to update it.
            draftState.customization.messenger.languagesLevel.values[index] =
                newSetting;
        });
    },
    [satisfactionSaveDixaMessengerLanguageLevelSettingsFailed.toString()](state) {
        return applyImmutably(state, (draftState) => {
            draftState.customization.messenger.languagesLevel.asyncStatus =
                'failed';
        });
    },
}, initialState);
